function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import h from './h';
import Gantt from './gantt';
import _render from './render/svg';
import { getFont } from './gantt/styles';
import { minDate, maxDate, textWidth, max } from './utils';

var SVGGantt = /*#__PURE__*/function () {
  function SVGGantt(element, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, SVGGantt);

    this.dom = typeof element === 'string' ? document.querySelector(element) : element;
    this.format(data);
    this.options = options;
    this.render();
  }

  _createClass(SVGGantt, [{
    key: "format",
    value: function format(data) {
      this.data = data;
      var start = null;
      var end = null;
      data.forEach(function (v) {
        start = minDate(start, v.start);
        end = maxDate(end, v.end);
      });
      this.start = start || new Date();
      this.end = end || new Date();
    }
  }, {
    key: "setData",
    value: function setData(data) {
      this.format(data);
      this.render();
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = _objectSpread(_objectSpread({}, this.options), options);
      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      var data = this.data,
          start = this.start,
          end = this.end,
          options = this.options;

      if (this.tree) {
        this.dom.removeChild(this.tree);
      }

      if (options.maxTextWidth === undefined) {
        var font = getFont(options.styleOptions || {});

        var w = function w(v) {
          return textWidth(v.text, font, 20);
        };

        options.maxTextWidth = max(data.map(w), 0);
      }

      var props = _objectSpread(_objectSpread({}, options), {}, {
        start: start,
        end: end
      });

      this.tree = _render(h(Gantt, _extends({
        data: data
      }, props)));
      this.dom.appendChild(this.tree);
    }
  }]);

  return SVGGantt;
}();

export { SVGGantt as default };